import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import Carousel from 're-carousel';
import IndicatorDots from '../../components/signup-ads-instagram-carousel-indicators/component'
import {BeatLoader} from "react-spinners";
import {langRegister} from "../../services/langRegister";
import {EventEmitter} from "../../services/eventRegister";
import {videoRegister} from "../../services/videoRegister";
import {Line} from "rc-progress";
import {videoRegisterNew} from "../../services/videoRegisterNew";
import {cartRegister} from "../../services/cartRegister";

class SignupAdsInstagramVideo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            video: null,
            thumbnail: "",
            progress: 0
        };
    };

    componentDidMount() {

        try {
            EventEmitter.on('video', (value) => {
                if(value){
                    this.setState({video: value.url, thumbnail: value.thumbnail});
                }
            });
        }catch (e) {}
        try {
            EventEmitter.on('video-error', (value) => {
                this.setState({error: value});
            });
        }catch (e) {}
        try {
            EventEmitter.on('video-progress', (value) => {
                this.setState({progress: value});
            });
        }catch (e) {}

        /*
        let data = videoRegister.get();
        let custom = videoRegisterNew.getCustom();
        if(data){
            this.setState({video: data.url, thumbnail: data.thumbnail});
        }
        if(custom){
            this.setState({video: custom.url, thumbnail: custom.thumbnail});
        }
        */
        try {
            let data = videoRegister.get();
            let admin_data = cartRegister.getCheckout();
            if(admin_data.admin_video){
                this.setState({video: admin_data.admin_video, thumbnail: admin_data.admin_video_thumbnail});
            }else if(data){
                this.setState({video: data.url, thumbnail: data.thumbnail});
            }
        }catch (e) {}
        try {
            let data = videoRegister.getError();
            this.setState({error: data});
        }catch (e) {}
        try {
            let progress = videoRegister.getProgress();
            this.setState({progress: progress});
        }catch (e) {}

    }

    _renderText(item) {
        return langRegister.get("signup-ads-facebook-video", item);
    }

    render() {
        return (
            <div className={
                cx(Styles.container,
                    {
                        [Styles.containerEmpty]: !this.state.video || this.state.error,
                    })
            }>
                <div className={Styles.containerItem}>
                    {
                        this.state.video && !this.state.error &&
                        <video muted={false} loop={true} autoplay={"autoplay"} width={"100%"} height={"100%"}>
                            <source src={this.state.video} type="video/mp4"/>
                        </video>
                    }
                    {
                        !this.state.video && !this.state.error &&
                        <div className={Styles.containerLoading}>
                            <div className={Styles.containerLoaderProgress}>
                                <Line percent={this.state.progress} strokeWidth="3" strokeLinecap={"square"} strokeColor="#41CBC7" />
                            </div>
                            <div className={Styles.containerLoadingText}>
                                {this._renderText("item_1")}
                            </div>
                        </div>
                    }
                    {
                        this.state.error &&
                        <div className={Styles.containerLoading}>
                            <div className={Styles.containerLoadingInner}>
                                <div className={cx(Styles.containerLoadingText, Styles. containerLoadingTextError)}>
                                    {this._renderText("item_2")}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default SignupAdsInstagramVideo;


// WEBPACK FOOTER //
// ./src/components/signup-ads-instagram-video/component.js